import { useQuery } from '@tanstack/react-query'
import { ExpertDoc, ExpertDocType } from 'packages/types'
import { baseClient } from 'builder/modules/apiClient'

type Params = {
  fetch?: boolean
  filterType?: ExpertDocType
}

export const useGetDocuments = (params?: Params) => {
  const { filterType, fetch = true } = params || {}

  const filterDocuments = (documents: ExpertDoc[]): ExpertDoc[] => {
    const mappedDocuments = documents.map(document => ({
      ...document,
      type: 'tr_document',
      createdAt: document.created_at as unknown as string,
    })) as ExpertDoc[]

    if (!filterType) return mappedDocuments
    return mappedDocuments.filter(document => document.doc_type === filterType)
  }

  const apiCall = async (): Promise<ExpertDoc[]> => {
    const { data } = await baseClient.get<ExpertDoc[]>('/documents')
    return filterDocuments(data)
  }

  return useQuery({
    queryKey: ['documents', filterType],
    queryFn: apiCall,
    useErrorBoundary: false,
    cacheTime: 0,
    enabled: fetch,
  })
}
